export const TABLE_TYPE_OPTIONS = {
  RECONCILIATION: { label: "Reconciliation", value: "RECONCILIATION" },
  BENEFICIAL_OWNER: { label: "Beneficial Owner", value: "BENEFICIAL_OWNER" },
  COMBINED: { label: "Combined", value: "COMBINED" },

};
